import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// FEATURE: BATTLE_MODE - Setup push notification listeners at app start
import { setupPushNotificationListeners } from './utils/notificationService';
import { initFacebookSdk } from './utils/facebookSdk';

// FEATURE: BATTLE_MODE - Setup push notification listeners at app start
// This ensures we don't miss the registration event
setupPushNotificationListeners();

// Facebook App Events (for Ads attribution on iOS/Android)
initFacebookSdk();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Note: The initial loader will be hidden by the Loader component
// once it's mounted and visible, to prevent white flash

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
